import {api} from './api';
import Http from '../http';
import URL from '../../data/api.js'
import CONFIG from '../../data/config.js'

const actions = {
  //  获取授权地址
  getAuthorizeUrl({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.getAuthorizeUrl
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  //  获取授权地址
  getSchoolDetail({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.getSchoolDetail
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },


  // 发送验证码
  sendMessageWithoutLogin({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.sendMessageWithoutLogin
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 检验验证码
  validMessageWithoutLogin({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.validMessageWithoutLogin
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 微信授权注册
  register({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.register
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 修改注册手机号
  modifyPhone({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.modifyPhone
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 账户信息首页
  getStudentAccount({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.getStudentAccount
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 学生账户列表
  queryStudentAccountList({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.queryStudentAccountList
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 切换当前账户
  switchStudentAccount({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.switchStudentAccount
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 添加账户
  addStudentAccount({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.addStudentAccount
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 学生账户列表
  queryStudentAccountList({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.queryStudentAccountList
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 邀请他人参加会议
  attendingMeeting({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.attendingMeeting
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 月度账单
  getBillList({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.getBillList
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 月度账单筛选
  getMonthBillDetail({commit}, params) {
    console.log(params)
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.getMonthBillDetail
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 月度账单筛选类型
  getBillTypeList({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.getBillTypeList
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 订单详情
  tradeDetail({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.tradeDetail
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 获取最小充值金额
  queryRechargeMinAmount({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.queryRechargeMinAmount
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 充值第一步
  getWxJsApiSign({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.getWxJsApiSign
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 充值第二步
  doRecharge({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.doRecharge
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 说明
  queryRechargeTitle({commit}, params) {
    let url = Http.getRequestUrl({
      urlName: 'baseUrl',
      url: api.queryRechargeTitle
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 学生待支付订单
  getStuRetryOrders({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.getStuRetryOrders
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    });
  },
  // 学生待支付订单详情
  getStuUnpayOrderDetail({commit}, params) {
    let url = Http.getRequestUrl({
      url: api.getStuUnpayOrderDetail
    });
    return Http.request(url, params, {method: 'POST'}).then(rep => {
      const data = rep.data;
      return rep;
    }, error => {
      return error;
    })
  }
}

export default actions;



// WEBPACK FOOTER //
// ./src/store/interfaceApi/actions.js